export default __webpack_public_path__ + "static/PXP-intro-7e45cd9682ee4fcac22c99c6fa926afa.mp4";